
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({


    modalImagen: false,
    modalFormUno: false,
    activoMoval: null,


    changeEstadoModalUno: async(estado, activo) => {
        set({ modalFormUno: estado, activoMoval: activo });
    },



    changeEstadoModalImagen: async(estado, activo) => {
        set({ modalImagen: estado, activoMoval: activo });
    },
    
    
});





export const useModalesStore = create()(
    devtools(
        storeApi
    )
)
